<template lang="pug">
  inline-svg(:src="fileSource" :width="size" :height="size")
</template>

<script lang="ts">
import Vue from "vue";
import InlineSvg from 'vue-inline-svg';
import {Component, Prop} from "vue-property-decorator";
const normalSvg = require('./google-auth-icon.svg');
const coloredSvg = require('./google-auth-icon-green.svg');

@Component({
  name: 'GoogleCodeLogo',
  components: {
    InlineSvg
  }
})
export default class GoogleCodeLogo extends Vue {
  @Prop({default: 32})
  size: number

  @Prop({default: false})
  colored: boolean

  get fileSource() {
    return this.colored ? coloredSvg : normalSvg;
  }
}
</script>

<style scoped>

</style>
